export var DEFAULT_EDIT_PLAYLIST_ROUTES = {
  editDetails: '/playlists/:playlistId/edit',
  editContent: '/playlists/:playlistId/edit/content',
  editContentPreview: '/playlists/:playlistId/edit/content/preview'
};